export default __webpack_public_path__ + "static/media/red.f5116e22.svg";